// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MostViewedListing-container-YnCiL {
    margin: 0 auto;
    max-width: 1274px;
    padding: 0 24px;
}

.MostViewedListing-pageContainer-M1cmU {
    padding-top: 60px;
}

.MostViewedListing-containerTitle-EeDxk {
    color: var(--common-text-color);
    margin: 0 0 35px;
    font-weight: bold;
    font-size: 36px;
    text-align: center;
}

.MostViewedListing-recommandBg-jL6KH {
    background-color: #F5FAFB;
    padding: 60px 0;
}

@media screen and (max-width: 1170px) {
    .MostViewedListing-containerTitle-EeDxk {
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/MostViewedListing/MostViewedListing.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".container {\n    margin: 0 auto;\n    max-width: 1274px;\n    padding: 0 24px;\n}\n\n.pageContainer {\n    padding-top: 60px;\n}\n\n.containerTitle {\n    color: var(--common-text-color);\n    margin: 0 0 35px;\n    font-weight: bold;\n    font-size: 36px;\n    text-align: center;\n}\n\n.recommandBg {\n    background-color: #F5FAFB;\n    padding: 60px 0;\n}\n\n@media screen and (max-width: 1170px) {\n    .containerTitle {\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MostViewedListing-container-YnCiL`,
	"pageContainer": `MostViewedListing-pageContainer-M1cmU`,
	"containerTitle": `MostViewedListing-containerTitle-EeDxk`,
	"recommandBg": `MostViewedListing-recommandBg-jL6KH`
};
module.exports = ___CSS_LOADER_EXPORT___;
